var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 21.4288C18.2793 21.4288 19.3694 20.9773 20.1731 20.1736C20.9768 19.3699 21.4284 18.2798 21.4284 17.1431C21.4284 16.0065 20.9768 14.9164 20.1731 14.1127C19.3694 13.309 18.2793 12.8574 17.1426 12.8574C16.006 12.8574 14.9159 13.309 14.1122 14.1127C13.3085 14.9164 12.8569 16.0065 12.8569 17.1431C12.8569 18.2798 13.3085 19.3699 14.1122 20.1736C14.9159 20.9773 16.006 21.4288 17.1426 21.4288Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1425 23.1434L20.1768 20.1777",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 3.42885C11.9998 2.74687 11.7289 2.09281 11.2466 1.61058C10.7644 1.12834 10.1103 0.857422 9.42836 0.857422H0.856934V18.0003H9.42836",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42871V11.143",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42885C12 2.74687 12.2709 2.09281 12.7532 1.61058C13.2354 1.12834 13.8894 0.857422 14.5714 0.857422H23.1429V12.8574",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakIcon);
export default __webpack_public_path__ + "static/media/break-icon.8e5a492ad90bef1b14c4015f54a0f7a0.svg";
export { ForwardRef as ReactComponent };